import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'pt-5',
    title: 'heading-2xl-desk max-sm:heading-2xl',
    description: 'heading-m mt-4',
    button: 'mt-10 w-[320px]'
  }
});
